var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['blw-icon', _vm.size]},[_c(_vm.customIconModule,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }